import type {DefaultError, UseQueryOptions} from "@tanstack/react-query";
import {useCustomQuery} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {CHAT_CONFIG} from "../services/ChatConfiguration";
import {supersetDashboardsUrl} from "../services/chatAgentApiUrls";
import type {UserDashboardRecord} from "../types/chatTypes";

export const SUPERSET_DASHBOARDS_QUERY_KEY_BASE = "/chat-agent/superset/dashboards";

/** Per-databag cache key (kept url-shaped to satisfy UrlQueryKey). */
export function supersetDashboardsQueryKey(databagId: number) {
    return [`${SUPERSET_DASHBOARDS_QUERY_KEY_BASE}?databag_id=${databagId}`] as const;
}

type SupersetDashboardsQueryKey = ReturnType<typeof supersetDashboardsQueryKey>;

/** The user's dashgen dashboards for a databag (`GET …/superset/dashboards`). */
export function useSupersetDashboards(
    databagId: number,
    options?: Omit<
    UseQueryOptions<
      UserDashboardRecord[],
      DefaultError,
      UserDashboardRecord[],
      SupersetDashboardsQueryKey
    >,
    "queryKey" | "queryFn"
  >,
) {
    return useCustomQuery<
    UserDashboardRecord[],
    DefaultError,
    UserDashboardRecord[],
    SupersetDashboardsQueryKey
  >({
        queryKey: supersetDashboardsQueryKey(databagId),
        queryFn: async () => {
            if (!CHAT_CONFIG.API_URL) {
                return [];
            }
            const {data} = await queryHttp.get<UserDashboardRecord[]>(supersetDashboardsUrl(databagId));
            return Array.isArray(data) ? data : [];
        },
        enabled: !!databagId,
        ...options,
    });
}
